<template>
  <SparklineChart v-if="paramsDefined"
                  :ag-grid-params="params"
                  :chart-specific-data="chartSpecificData"></SparklineChart>
</template>

<script>
  import { translator } from '~/zf/frontend/common/mixins';
  import SparklineChart from '../components/SparklineChart.vue';

  export default {
    name: 'SparklineChartIrradiationSatellite',
    components: {
      SparklineChart,
    },
    mixins: [translator],
    data() {
      return {
        chartSpecificData: {
          type: 'irradiation',
          color: '#ffc125',
          unit: this.tr('common.units.IRRADIANCE'),
          unitAggregated: this.tr('common.units.IRRADIANCE_AGGREGATED'),
          dataColumn: 'G_M_SAT',
          chartDataColumn: 'G_M0_SATELLITE_SPARKLINE',
        },
      };
    },
    computed: {
      paramsDefined() {
        return this.params.value !== undefined;
      },
    },
  };
</script>
